// client/src/components/landing/LandingHeroB.js
// 랜딩 히어로 (v6 B안 확정) — 다크 그라디언트 + 실제 마이비즈 화면 폰 목업 2대 + 플로팅 알림 칩
// 모바일(≤640px)에선 폰·칩 2세트가 교차 페이드로 번갈아 표시 (LandingB.css)
import React from 'react';
import { useNavigate } from 'react-router-dom';

function LandingHeroB() {
  const nav = useNavigate();

  return (
    <section className="heroB">
      <div className="heroB__in">
        <div>
          <span className="eyebrow">나노·마이크로 인플루언서 마케팅 플랫폼</span>
          <h1>광고주와 인플루언서,<br /><b>서로에게 직접</b> 닿는 플랫폼</h1>
          <p className="sub">
            대행 마진 대신 3명당 5,000원의 수수료. 모집·선정·검수·정산이 한 화면에서 끝나고,
            보상은 검수 즉시 — 늦어도 7일이면 자동으로 지급돼요.
          </p>
          <div className="row">
            <button type="button" className="lnd-btn lnd-btn--blue lnd-btn--lg" onClick={() => nav('/marketer/register')}>
              광고주로 시작하기
            </button>
            <button type="button" className="lnd-btn lnd-btn--mint lnd-btn--lg" onClick={() => nav('/influencer/register')}>
              인플루언서로 시작하기
            </button>
          </div>
          <div className="chips">
            <span>🛡️ 양측 검증제</span>
            <span>📱 인스타 · 유튜브 · 블로그 · 틱톡</span>
            <span>↩️ 미사용 예산 자동 환원</span>
          </div>
        </div>

        <div className="heroB__stage" aria-hidden="true">
          <div className="heroB__float heroB__float--a"><i>🎉</i>선정됐어요! 계약 응답 대기 1건</div>
          <div className="heroB__float heroB__float--b"><i>💸</i>환전 완료 · 영업일 1~3일 입금</div>

          {/* 폰 1: 광고주 비즈 홈 */}
          <div className="phone">
            <div className="phone__screen">
              <div className="phone__bar"><div className="phone__notch" /></div>
              <div className="scr">
                <div className="scr__title">비즈 홈</div>
                <div className="lnd-wallet lnd-wallet--blue">
                  <div className="lnd-wallet__label">보유 포인트</div>
                  <div className="lnd-wallet__amt num">2,450,000P</div>
                </div>
                <div className="mcard mcard--blue">
                  <div className="mcard__row">
                    <span className="mcard__logo" style={{ background: '#f59e0b' }}>그</span>
                    <span className="mcard__meta">
                      <span className="mcard__name">수제 그래놀라 세트</span>
                      <span className="mcard__sub">검수 대기 2건 · 자동 승인 D-5</span>
                    </span>
                    <span className="mcard__amt">D-5</span>
                  </div>
                  <div className="lnd-pipe"><i className="is-done" /><i className="is-done" /><i className="is-done" /><i className="is-now" /><i /><i /></div>
                </div>
                <div className="mcard mcard--blue">
                  <div className="mcard__row">
                    <span className="mcard__logo" style={{ background: '#7c5cff' }}>샴</span>
                    <span className="mcard__meta">
                      <span className="mcard__name">두피 샴푸 체험단</span>
                      <span className="mcard__sub">지원 12명 · 선정 대기</span>
                    </span>
                    <span className="mcard__amt">12명</span>
                  </div>
                  <div className="lnd-pipe"><i className="is-done" /><i className="is-now" /><i /><i /><i /><i /></div>
                </div>
              </div>
            </div>
          </div>

          {/* 폰 2: 인플루언서 활동 홈 */}
          <div className="phone phone--second">
            <div className="phone__screen">
              <div className="phone__bar"><div className="phone__notch" /></div>
              <div className="scr">
                <div className="scr__title">활동 홈</div>
                <div className="lnd-wallet lnd-wallet--mint">
                  <div className="lnd-wallet__label">보유 포인트</div>
                  <div className="lnd-wallet__amt num">1,284,000P</div>
                </div>
                <div className="mcard">
                  <div className="mcard__row">
                    <span className="mcard__logo" style={{ background: '#2f6bff' }}>이</span>
                    <span className="mcard__meta">
                      <span className="mcard__name">무선 이어폰 리뷰</span>
                      <span className="mcard__sub">계약 응답 대기 · 내일까지</span>
                    </span>
                    <span className="mcard__amt in">100,000P</span>
                  </div>
                  <div className="lnd-pipe"><i className="is-done" /><i className="is-done" /><i className="is-now" /><i /><i /><i /></div>
                </div>
                <div className="mcard">
                  <div className="mcard__row">
                    <span className="mcard__logo" style={{ background: '#0fb37a' }}>카</span>
                    <span className="mcard__meta">
                      <span className="mcard__name">브런치 카페 리뷰</span>
                      <span className="mcard__sub">승인 완료 · 보상 지급됨</span>
                    </span>
                    <span className="mcard__amt in">+40,000</span>
                  </div>
                  <div className="lnd-pipe"><i className="is-done" /><i className="is-done" /><i className="is-done" /><i className="is-done" /><i className="is-done" /><i className="is-done" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="heroB__fade" />
    </section>
  );
}

export default LandingHeroB;
